import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_ALL_GATER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/gater`;
